export { default as PhoneInput } from './PhoneInput';
